import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { User } from 'lucide-react';
import { Label } from '@/components/ui/label';

const AVAILABLE_AVATARS = ['m1.png', 'm2.png', 'm3.png', 'f1.png', 'f2.png', 'f3.png'];

interface AvatarSelectorFormProps {
  selectedAvatar: string;
  onAvatarSelect: (avatar: string) => void;
}

export function AvatarSelectorForm({ selectedAvatar, onAvatarSelect }: AvatarSelectorFormProps) {
  return (
    <div className="space-y-2">
      <Label className="text-[#666666] text-sm">Select an avatar</Label>
      <div className="flex flex-wrap gap-3">
        {AVAILABLE_AVATARS.map((avatar) => (
          <button
            key={avatar}
            type="button"
            onClick={() => onAvatarSelect(avatar)}
            className={`relative rounded-full transition-all ${
              selectedAvatar === avatar
                ? 'ring-4 ring-wabisabi-plum ring-offset-2'
                : 'hover:ring-2 hover:ring-gray-300 hover:ring-offset-2'
            }`}
          >
            <Avatar className="w-16 h-16">
              <AvatarImage src={`/images/avatars/${avatar}`} alt={avatar} />
              <AvatarFallback className="bg-gray-200">
                <User className="w-8 h-8 text-gray-500" />
              </AvatarFallback>
            </Avatar>
          </button>
        ))}
      </div>
    </div>
  );
}
